/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_CategoriesInputs */

const vi_shop_home_link_categories = /** @type {(inputs: Shop_Home_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục bán`)
};

/**

* @param {Shop_Home_Link_CategoriesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_categories = /** @type {((inputs?: Shop_Home_Link_CategoriesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_CategoriesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_categories(inputs)
});